// The four overall-status values that mean a case is "lost". Shared so the Case Status
// dropdown block-list and the "Report Case Lost" button cannot drift apart.
export const LOST_OVERALL_STATUSES = [
  "Lost",
  "Lost - Confirmed",
  "Lost - Recoverable",
  "Lost - Pending Lost Documents",
];

export const MEDICALLY_COMPLETE_LOCK_MESSAGE =
  "This case is medically complete. You do not have permission to change it.";
